<!--  -->
<template>
  <div class="news">
    <HomeNav></HomeNav>
    <PhoneNav></PhoneNav>
    <CrumbsNav :crumbsnav="crumbsnav"></CrumbsNav>
    <NewsNav
      @child-id="parentId"
      @child-year="parentYear"
      @child-id-year="parentIdYear"
    ></NewsNav>
    <NewsList :newsList="newsList"></NewsList>

    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 30]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagetotal"
      >
      </el-pagination>
    </div>

    <BottomNav></BottomNav>
  </div>
</template>

<script>
import HomeNav from "../components/HomeNav.vue";
import PhoneNav from "../components/PhoneNav.vue";
import CrumbsNav from "../components/CrumbsNav.vue";
import NewsNav from "../components/news/NewsNav.vue";
import NewsList from "../components/news/NewsList.vue";
import BottomNav from "../components/BottomNav.vue";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    HomeNav,
    PhoneNav,
    CrumbsNav,
    NewsNav,
    NewsList,
    BottomNav,
  },
  data() {
    //这里存放数据
    return {
      crumbsnav: [
        /* 
        {
          title: "首页",
          url: "/index",
        },
        {
          title: "关于堃博",
          url: "/aboutUs*",
        },
       */
      ],
      childId: "",
      childyear: "",
      newsList: [
        /* 
        {
          time: "2020-01-08",
          year: "2020",
          month: "01-08",
          title:
            "Ballet®(芭蕾)腔静脉滤器在上海交通大学附属第六人民医院首例临床应用成功",
          msg: "2019年11月8日，一枚预防致死性肺栓塞的最新型下腔静脉滤器在上海交通大学附属第六人民医院血管外科成功置入一位下肢深静脉血栓患者的腔静脉内，并于体内存留56天、消除肺栓塞风险后成功取出。",
        },
        {
          time: "2021-02-24",
          year: "2021",
          month: "02-24",
          title:
            "DragonFly™经导管二尖瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统",
          msg: "2020年9月29日，在今年的世界心脏日当天，浙江大学医学院附属第二医院(浙二医院)王建安教授团队应用DragonFly™二尖瓣瓣膜夹...",
        },
        {
          time: "2021-02-24",
          year: "2021",
          month: "02-24",
          title:
            "DragonFly™经导管二尖瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统",
          msg: "2020年9月29日，在今年的世界心脏日当天，浙江大学医学院附属第二医院(浙二医院)王建安教授团队应用DragonFly™二尖瓣瓣膜夹...",
        },
        {
          time: "2021-02-24",
          year: "2021",
          month: "02-24",
          title:
            "DragonFly™经导管二尖瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统",
          msg: "2020年9月29日，在今年的世界心脏日当天，浙江大学医学院附属第二医院(浙二医院)王建安教授团队应用DragonFly™二尖瓣瓣膜夹...",
        },
        {
          time: "2021-02-24",
          year: "2021",
          month: "02-24",
          title:
            "DragonFly™经导管二尖瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统",
          msg: "2020年9月29日，在今年的世界心脏日当天，浙江大学医学院附属第二医院(浙二医院)王建安教授团队应用DragonFly™二尖瓣瓣膜夹...",
        },
       */
      ],

      //默认第几页
      currentPage: 1,
      //总条数
      pagetotal: 0,
      //每页多少条 默认为5
      pagesize: 10,
      pagesizes: 10,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route(to, from) {
      this.childId = parseInt(this.$route.query.cid);
      this.get_chushi(this.childId);
      if (this.$route.query.cid == "") {
        this.get_chushi();
      }
    },
  },
  //方法集合
  methods: {
    parentId(data) {
      this.childId = data;
      console.log(this.childId);
      this.currentPage = 1;
    },
    parentIdYear(data) {
      var year = data;
      console.log(year);
      this.get_data(this.childId, year);
    },

    parentYear(data) {
      this.childyear = data;
      console.log(this.childyear);
      this.currentPage = 1;
      this.get_data(this.childId, this.childyear);
    },
    //1.得到初始值
    get_chushi(a) {
      if (a == "") {
        $.ajax({
          url: "/index.php?s=Home/Api/get_data",
          type: "get",
          datatype: "json",
          async: false,
          data: {
            act: "get_two_class",
            id: 5,
          },
          success: function (ret) {
            var obj = JSON.parse(ret); //json数据转为数组
            if (obj.code == "0000") {
              that.childId = obj.data[0].id;
              a = obj.data[0].id;
              //alert(obj.data[0].id);
            }
          },
          error: function (err) {
            console.log("ajax错误");
          },
        });
      }
      var b = "0";
      const that = this;

      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        async: false,
        data: {
          act: "get_years",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.childyear = obj.data[0];
            b = obj.data[0];
            //alert(obj.data[0]);
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
      this.currentPage = 1;
      this.get_data(a, b);
    },
    //2.文章列表
    get_data(childId, childyear) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: childId,
          year: childyear,
          xiaji: 1,
          show_num: that.pagesizes, //每页显示几条
          page: that.currentPage, //当前第几页
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.newsList = [];
            that.pagetotal = obj.data[0].total_nums; //总条数
            $.each(obj.data, function (i, k) {
              that.newsList.push({
                id: k.id,
                time: k.create_times,
                year: k.year,
                month: k.month + "-" + k.day,
                title: k.title,
                msg: k.description,
                src: k.pic_f,
                url: "/Msgdetails?id=" + k.id,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //切换每页显示多少条数据方法
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //更新列表数据
      this.pagesize = val;
      this.pagesizes = val;
      this.get_data(this.childId, this.childyear);
    },
    // 切换页数
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      //更新列表数据
      this.currentPage = val;
      this.get_data(this.childId, this.childyear);
    },
    //面包屑
    get_mianbao() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        async: false,
        data: {
          act: "get_all_nav_parent",
          nid: 4,
          showlast: 1,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.crumbsnav = [];
            $.each(obj.data, function (i, k) {
              that.crumbsnav.push({
                title: k.title,
                url: k.url,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_mianbao();
    this.childId = parseInt(this.$route.query.cid);
    this.get_chushi(this.childId);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.page {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 50px 0 50px;
}
@media screen and (max-width: $main-width) {
  .page {
    width: 100%;
    .el-pagination {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
    .el-pagination >>> .el-pagination__jump {
      margin-top: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/news.vue